<span style="">
                <a style="color:#171716; text-decoration: none; margin-right: 5px; position: relative; top:0px; border-radius: 100px; background: #fabc09; padding: 0px 6px" href="javascript:void(0)" (click)="decrementPersonCount()">-</a>
                <span class="ng-binding personCount">{{cartElement.personCount}}</span>
                <a style="color:#171716; text-decoration: none; margin: 0px 5px;  position: relative; top:0px;  border-radius: 100px; background: #fabc09; padding: 0px 6px" href="javascript:void(0)" (click)="incrementPersonCount()">+</a>

</span>
